<script setup lang="ts">
import type { Icons } from '@/components/base/BaseIcon.vue'

const props = withDefaults(
  defineProps<{
    module?: string
    color: string
  }>(),
  {
    module: 'survey'
  }
)

const { merchantName, user } = useLocalStorage()
const { t } = useI18n()
const { getContrast } = useColor()
const { isPolite } = useMerchantTexts()

const bgImg = computed(() => `${import.meta.env.VITE_AWS_STORAGE_URL}/b2c/webapp/slider/star-pattern.png`)

const icon = computed<Icons | ''>(() => {
  switch (props.module) {
    case 'wallet':
      return 'HeroWalletIconSolid'
    case 'survey':
      return 'HeroMegaphoneIconOutline'
    case 'crm':
      return 'HeroUserIconOutline'
    case 'review':
      return 'HeroHeartIconOutline'
    case 'contest':
      return 'HeroGiftIconOutline'
    default:
      return ''
  }
})

const btnText = computed(() =>
  props.module === 'wallet'
    ? t('pages.loyaltyPage.mockup.devices.webapp.discussionCard.btnText.add')
    : t('pages.loyaltyPage.mockup.devices.webapp.discussionCard.btnText.points', { number: 5 })
)

const emit = defineEmits<(e: 'onClick', module: string) => void>()

const title = computed(() => {
  if (user.value.languageId === 21) {
    return t(
      `pages.loyaltyPage.mockup.devices.webapp.discussionCard.title.${props.module}.${
        isPolite.value ? 'polite' : 'base'
      }`,
      {
        merchantName: merchantName.value
      }
    )
  } else {
    return t(`pages.loyaltyPage.mockup.devices.webapp.discussionCard.title.${props.module}`, {
      merchantName: merchantName.value
    })
  }
})

const description = computed(() => {
  if (user.value.languageId === 21) {
    return t(
      `pages.loyaltyPage.mockup.devices.webapp.discussionCard.subtitle.${props.module}.${
        isPolite.value ? 'polite' : 'base'
      }`,
      { points: 5 }
    )
  } else {
    return t(`pages.loyaltyPage.mockup.devices.webapp.discussionCard.subtitle.${props.module}`, { points: 5 })
  }
})
</script>

<template>
  <div
    class="bg-slate-white flex h-full items-end rounded-xl border bg-white bg-contain bg-top-right bg-no-repeat"
    :style="{ backgroundImage: `url(${bgImg})` }"
    @click="emit('onClick', module)"
  >
    <div class="flex h-full w-full flex-col justify-between px-3 py-5">
      <div>
        <div class="flex items-center">
          <BaseIcon v-if="icon" :name="icon" class="mr-2 size-7" :style="{ color: color }" />
          <p class="w-full font-semibold leading-4 text-foreground">{{ title }}</p>
        </div>
        <p class="mb-3 w-full text-xs font-medium text-foreground-secondary">{{ description }}</p>
      </div>
      <div class="text-end">
        <Button
          class="rounded-full w-fit text-xs border-none px-2! py-1!"
          :style="`color: ${getContrast(color)}!important; background-color: ${color}!important;`"
        >
          <span class="font-bold">
            {{ btnText }}
          </span>
          <BaseIcon name="HeroArrowRightIconSolid" class="ml-2 size-5" />
        </Button>
      </div>
    </div>
  </div>
</template>
